import React from 'react';
// add / at the beginingif not start with http(s) or /
export function makeValidUrl(url) {
  if (url.startsWith('http') || url.startsWith('/')) {
    return url;
  }
  return `/${url}`;
}

export function getNavTag({ tag, pathname, url, name, customClass }) {
  if (tag === 'NEW' && pathname !== url) {
    return (
      <span className={customClass? "tag-ic newTag abs ":"tag-ic newTag"}>
        NEW
      </span>
    );
  }
  if (tag === 'HOT') {
    return (
      <span className={customClass? "tag-ic hotTag abs ":"tag-ic hotTag"} >
        HOT
      </span>
    );
  }
}
